import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const forWorkUpgradeTariff2 = getFeature('for-work-upgrade-tariff2') as Record<number, string>;

/** id промо - для включения нужно будет включать фичу app.enableFeature('3promo-enable-upgrade-for-work-modal2') */
export const PROMO_ID = 'upgrade-for-work-modal2';

export const config = getFeature(`${PROMO_ID}-config`) || {
    showLimit: 3,
    closeLimit: 3,
    showInterval: 60 * 60 * 24 * 3,
};
